import { List as TemplateList } from "~/features/article";
import { getRouteApi, useNavigate } from "@tanstack/react-router";

export const List = () => {
  const getRoute = getRouteApi("/_layout/article/community/");
  const result = getRoute.useLoaderData();
  const params = getRoute.useSearch();

  const navigate = useNavigate({
    from: "/article/kiat-kiat",
  });

  return (
    <TemplateList
      title="Kabar Komunitas"
      hash="Komunitas"
      description="Temukan informasi kabar komunitas"
      items={result.data.list}
      onPageChange={(v) => {
        navigate({
          search: (prev) => {
            return {
              ...prev,
              page: v.page,
            };
          },
        });
      }}
      paging={{
        count: result.data.paging.count,
        limit: result.data.paging.limit,
      }}
      page={params.page}
    />
  );
};
